import * as yup from 'yup';

export const pushNotificationFormSchema = yup.object().shape({
  title: yup.string().required('É necessário informar um título.'),
  message_body: yup.string().required('É necessário informar uma mensagem.'),
  target: yup.string(),
});
